import { State } from './interfaces/state.interface';
import { ActionType as AT } from './enums/action-type.enum';

export const addState = (state:State) => ({
	type: AT.ADD_STATE as typeof AT.ADD_STATE,
	payload: state
});

export const rollBackState = () => ({
	type: AT.ROLL_BACK_STATE as typeof AT.ROLL_BACK_STATE
});

export const setState = (state:State) => ({
	type: AT.SET_STATE as typeof AT.SET_STATE,
	payload: state
});